import _extends from "@babel/runtime/helpers/extends";
import React, { useContext } from 'react';
import styled from 'styled-components';
import { ModalContentItemContext } from './context';
import { SHADOW_DEFAULT } from '../shadows';
import { MODAL_HORIZONTAL_PADDING, MODAL_VERTICAL_PADDING } from './constants';
import { paddingVertical } from '../style/padding-vertical';
import { paddingHorizontal } from '../style/padding-horizontal';
const StyledFooterWrapper = styled.div`
  ${({
  $hasSafeBottomPadding
}) => $hasSafeBottomPadding && 'padding-bottom: env(safe-area-inset-bottom);'}
`;
const StyledModalFooter = styled.div`
  ${({
  $noShadow
}) => !$noShadow && `box-shadow: ${SHADOW_DEFAULT};`}
  ${paddingHorizontal(MODAL_HORIZONTAL_PADDING)}
  ${paddingVertical(MODAL_VERTICAL_PADDING)}
`;
const ModalFooter = ({
  children,
  noShadow = false,
  ...props
}) => {
  const {
    last
  } = useContext(ModalContentItemContext);
  return /*#__PURE__*/React.createElement(StyledModalFooter, _extends({
    $noShadow: noShadow
  }, props), /*#__PURE__*/React.createElement(StyledFooterWrapper, {
    $hasSafeBottomPadding: last
  }, children));
};
export default ModalFooter;